import axios from 'axios';
import { toast } from 'react-hot-toast';
import { errorMessage } from '../utils/message';

import config from './config.json';
const { kalapost } = config;

const kalapostAPI = axios.create({
   baseURL: kalapost,
   xsrfCookieName: 'scypher',
   xsrfHeaderName: 'ssign',
});

kalapostAPI.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.response.use(null, (error) => {
   const expectedErrors =
      error.response && error.response.status >= 400 && error.response.status < 500;
   if (!expectedErrors) {
      toast.error('مشکلی از سمت سرور رخ داده است.', {
         position: 'top-right',
         closeOnClick: true,
      });
   }
   return Promise.reject(error);
});

export const setAuthToken = (accessToken) => {
   if (accessToken) {
      kalapostAPI.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
   } else {
      delete kalapostAPI.defaults.headers.common['Authorization'];
   }
};

export const getErrorType = (error) => {
   try {
      if (error.response) {
         return { error: true, errorType: 'response', errorBody: error.response };
      } else if (error.request) {
         return { error: true, errorType: 'request', errorBody: error.request };
      } else {
         return { error: true, errorBody: error.message };
      }
   } catch (error) {
      console.log(error);
   }
};
export const showErrorMessage = (result) => {
   let msg = '';

   try {
      switch (result.errorType) {
         case 'request':
            return errorMessage('خطای دسترسی به اینترنت');
         case 'response':
            msg = result?.errorBody?.data?.message;
            if (msg && typeof msg === 'string') {
               return errorMessage(result.errorBody.data.message);
            }
            return errorMessage('مشکلی وجود دارد!');

         default:
            msg = result.errorBody.message || result.errorBody;
            if (msg && typeof msg === 'string') {
               return errorMessage(result.errorBody.message || result.errorBody);
            }
            return errorMessage('مشکلی وجود دارد!');
      }
   } catch (error) {
      console.log(error);
   }
};

export default kalapostAPI;
